import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useLayoutEffect, useState } from 'react';

import img1 from '@/assets/images/features1.webp';
import img2 from '@/assets/images/features2.webp';
import img3 from '@/assets/images/features3.webp';
import img4 from '@/assets/images/features4.webp';
import videoPreview from '@/assets/images/play2.webp';

import Modal from '@/components/Modals/Modal/Modal';

import styles from './Features.module.scss';

function Card({ cardClass, imgSrc, children }) {
  return (
    <div className={`${styles.card} ${cardClass ? cardClass : ''}`}>
      <img className={`${styles.cardImg} lazyload`} src={imgSrc} width={300} height={300} alt={children} />

      <p className={styles.cardText}>{children}</p>
    </div>
  );
}

function Features() {
  gsap.registerPlugin(ScrollTrigger);

  useLayoutEffect(() => {

    const mm = gsap.matchMedia();

    mm.add('(min-width: 991px)', () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: `.${styles.cards}`,
          start: 'top top',
          end: 'bottom -=100%',
          scrub: true,
          pin: true,
        },
      });

      tl.fromTo(
        `.${styles.card1}`,
        { opacity: 1, x: 500, y: 500 },
        { opacity: 1, x: 0, y: 0, rotation: -5 }
      ).fromTo(
        `.${styles.card2}`,
        { opacity: 1, x: 300, y: 400 },
        { opacity: 1, x: 0, y: 0, rotation: 8 },
        '-=0.5'
      ).fromTo(
        `.${styles.card3}`,
        { opacity: 1, x: -400, y: 500 },
        { opacity: 1, x: 0, y: 0, rotation: 12 },
        '-=0.5'
      ).fromTo(
        `.${styles.card4}`,
        { opacity: 1, x: -250, y: 400 },
        { opacity: 1, x: 0, y: 0, rotation: -12 },
        '-=0.5'
      );
    });
  }, []);

  const [isOpenVideo, setIsOpenVideo] = useState(false);

  return (
    <section className={styles.features}>
      <div className={styles.top}>
        <h2 className={styles.title}>Что тебя ждёт на забег.рф?</h2>
        <div className={styles.buttonWrap}>
          <p className={styles.subtitle}>Смотри, как это было в прошлом году!</p>

          <button className={styles.button} onClick={() => setIsOpenVideo(true)}>
            <span className="visually-hidden">Посмотреть видео</span>
          </button>
        </div>
      </div>

      <div className={styles.cards}>
        <Card cardClass={styles.card1} imgSrc={img1}>
          Участие детей и развлечения для юных атлетов
        </Card>
        <Card cardClass={styles.card2} imgSrc={img2}>
          4 дистанции для любого уровня подготовки
        </Card>
        <Card cardClass={styles.card3} imgSrc={img3}>
          Лучшие маршруты в сердце твоего города
        </Card>
        <Card cardClass={styles.card4} imgSrc={img4}>
          Шоу-программа для болельщиков и участников
        </Card>
      </div>
      <div className={styles.arch}></div>

      <Modal isOpen={isOpenVideo} onClose={() => setIsOpenVideo(false)} closeBtnStyles={styles.closeBtn}>
        <div className={styles.videoWrap}>
          <video className={styles.videoFrame} poster={videoPreview} controls="controls">
            <source src="https://heroleague.ru/video/zabeg2024.mp4" type="video/mp4" />
          </video>
        </div>
      </Modal>
    </section>
  );
}

export default Features;
